
<div class="login-box">
    <div class="login-box--header">MCD Auth Admin</div>
    <button type="button" [disabled]="isBusy" (click)="doLogin()" class="btn btn-block btn-primary">Login</button>
</div>
